<template>
  <span>
    <v-tooltip v-model="showTooltip" top :disabled="disabled">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon small color="secondary">mdi-help-circle</v-icon>
        </v-btn>
      </template>
      <span>{{text}}</span>
    </v-tooltip>
  </span>
</template>

<script>

export default {
  name: "HelpIcon",
  components: {},
  props: {
    text: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: function() {
    return {
      showTooltip: false,
    };
  },
  methods: {
  }
};
</script>